export default {
    name: 'navbarSection',
    // created: {
    // },

};
